import React from 'react';
import PropTypes from 'prop-types';
import {trackEvent} from '../../utils/tracking.js';
import { withGigCardContext } from '../gig_card_context';

const Username = ({ name, url, prefix, cardType, cardSize }) => (
    <a href={url} rel="nofollow" className="seller-name" onClick={() => trackEvent('username', cardType, cardSize)}>
        {prefix ? `${prefix} ` : ''}
        {name}
    </a>
);


Username.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    prefix: PropTypes.string,
    cardType: PropTypes.string
};

const contextSelector = ({ cardType, cardSize }) => ({ cardType, cardSize });

export default withGigCardContext(contextSelector)(Username);



// WEBPACK FOOTER //
// ./src/shared/username/index.js